import { z } from 'zod';
import { IdSchema, IsoDateTimeSchema, nullableText } from './common.js';
import { PaymentMethodSchema } from './enums.js';
import { MoneySchema, parseTiyin } from './money.js';
import { OrderPaymentStateSchema } from './payment.js';
import { ShipmentResponseSchema } from './shipment.js';
/**
 * Kuryer oqimi.
 *
 * KUCHLI QOIDA — "kuryerga qachon ko'rinadi": jo'natma kuryerga FAQAT unga
 * biriktirilgach (`Shipment.courierId = kuryer`) va hali yakunlanmagan
 * ("active" — `OUT_FOR_DELIVERY`) bo'lsa ko'rinadi. Biriktirish va yuborish
 * bitta amal: dispetcher kuryerni tanlab "Kuryerga topshirish" bosadi, shu
 * zahoti status `OUT_FOR_DELIVERY` bo'ladi va kuryer ro'yxatida paydo bo'ladi.
 * Boshqa kuryer (hatto shu do'kondagi ham) uni ko'rmaydi.
 */
/** Biriktirish uchun tanlanadigan kuryer. */
export const CourierResponseSchema = z.object({
    id: IdSchema,
    firstName: nullableText(80),
    lastName: nullableText(80),
    phone: nullableText(20),
    shopId: IdSchema,
    shopNameUz: z.string(),
});
export const ListCouriersQuerySchema = z.object({ shopId: IdSchema }).strict();
/** `active` — yo'ldagi (hozir yetkazish kerak); `done` — oxirgi natijalar (yetkazildi / yetkazilmadi). */
export const MY_SHIPMENT_SCOPES = ['active', 'done'];
export const MyShipmentScopeSchema = z.enum(MY_SHIPMENT_SCOPES);
export const ListMyShipmentsQuerySchema = z
    .object({ scope: MyShipmentScopeSchema.default('active') })
    .strict();
/**
 * Kuryer ko'radigan yetkazma: faqat o'z jo'natmasi va buyurtmaning KERAKLI
 * qismi (mijoz, manzil, to'lov HOLATI). Buyurtmaning boshqa jo'natmalari,
 * boshqa do'kon tovarlari va BUTUN buyurtma summasi bu yerda YO'Q: bo'lingan
 * buyurtmada kuryer boshqa do'kon qismining summasini bilmasligi (va uni
 * so'ramasligi) kerak. Olinadigan summa — `shipment.itemsTotal`.
 *
 * "Natijalar" (`done`) ro'yxatida mijoz telefoni, manzil va kelishuv `null`:
 * yetkazib bo'lingach kuryerga kerak emas (ma'lumot minimizatsiyasi).
 */
export const MyShipmentResponseSchema = z.object({
    shipment: ShipmentResponseSchema,
    order: z.object({
        id: IdSchema,
        number: z.string(),
        customerName: z.string(),
        customerPhone: z.string().nullable(),
        regionNameUz: z.string().nullable(),
        addressLine: nullableText(255),
        /** Kelishilgan yetkazish sharti. */
        operatorNote: nullableText(1000),
        paymentMethod: PaymentMethodSchema,
        paymentState: OrderPaymentStateSchema,
        /** Hali olinmagan summa (tiyin): buyurtma summasi − tasdiqlangan − kutilayotgan. Yakunlanganda null. */
        amountDue: z.string().nullable(),
    }),
    statusChangedAt: IsoDateTimeSchema,
});
/** Kuryer faqat ikki natija bera oladi. Qolgan o'tishlar uning ruxsatida emas. */
export const COURIER_RESULT_CODES = ['DELIVERED', 'FAILED_DELIVERY'];
export const CourierResultSchema = z
    .object({
    toCode: z.enum(COURIER_RESULT_CODES),
    /** Yetkazilmasa sabab majburiy (status jadvalidagi `requiresComment`). */
    comment: z.string().trim().max(500).optional(),
})
    .strict();
/** Kuryer olgan naqd pul. Usul har doim CASH, yozuv PENDING — tasdiqlashni kassir qiladi. */
export const CourierCashSchema = z
    .object({ amount: MoneySchema })
    .strict()
    .refine((v) => (parseTiyin(v.amount) ?? 0n) > 0n, {
    message: "To'lov summasi musbat bo'lishi kerak",
    path: ['amount'],
});
//# sourceMappingURL=courier.js.map